export default function Callout({ children }) {
    return (
        <div className="w-full bg-blue-superlight rounded mb-8 py-6 max-w-screen-md m-auto">
            <div className="title-font font-medium w-full text-gray-dark px-8 pb-0 text-center">
                {children}
            </div>
        </div>
    );
}
